module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Medium.064f8ac2.eot";